import React, { useRef, useState } from 'react';
import Slider from 'rc-slider';
import styles from './CustomThumbnailModalCustom.module.scss';

import marker from './pos.svg';
import FloatingContainer from '../../routes/newVideo/VideoTrimmingControls/FloatingContainer';
import TimeInput from '../TimeInput/TimeInput';
import Waveform from '../Waveform/Waveform';
import Spinner from '../../../common/components/Spinner';

const ThumbnailSlider = ({ waveform, onSeekChange, currentValue, videoDuration, emptyThumbnail }) => {
  const trimContainerRef = useRef(null);

  const [startTimeInput] = useState(0);

  return (
    <div ref={trimContainerRef}>
      <div className={styles.slidersWrapper}>
        <>
          <Slider
            className={styles.videoProgress}
            trackStyle={{
              backgroundColor: 'transparent',
              borderRadius: '0',
              height: '56px',
              top: '30%',
              border: '0px',
            }}
            handleStyle={{
              backgroundImage: `url(${marker})`,
              backgroundPosition: '50% 0%',
              borderRadius: '0',
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
              cursor: 'default',
              backgroundRepeat: 'no-repeat',
              backgroundColor: 'transparent',
              zIndex: '999',
              marginLeft: '-12px',
              top: '-19px',
              height: '80px',
              width: '25px',
              display: emptyThumbnail ? 'none' : 'block',
            }}
            railStyle={{
              zIndex: '999',
              height: '56px',
              border: '1px solid #BDBDBD',
              background: 'transparent',
              borderRadius: '4px',
              boxShadow: 'none',
            }}
            min={0}
            max={1}
            step={0.001}
            onChange={onSeekChange}
            value={currentValue}
            included
          />
          {waveform ? (
            <div className={styles.waveformContainer}>
              <Waveform
                waveformData={waveform.map(item => item * 10000)}
                parentRef={trimContainerRef}
                trimStartPos={startTimeInput / videoDuration}
                progress={1}
              />
            </div>
          ) : (
            <Spinner width="30px" height="30px" size="3px" className={styles.spinnerIcon} />
          )}

          {!emptyThumbnail && (
            <FloatingContainer
              parentRef={trimContainerRef}
              floatingValue={currentValue}
              correction={18}
              className={styles.progressContainer}
            >
              <TimeInput
                className={styles.timeInput}
                disabled={true}
                value={(currentValue * videoDuration) / 1000}
                variant="basic"
                showControls={false}
              />
            </FloatingContainer>
          )}
        </>
      </div>
    </div>
  );
};

export default ThumbnailSlider;
